import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UrlShortnerService {
  private baseUrl = environment.urlShortnerBaseUrl;
  constructor( private httpClient: HttpClient ){ }

  shortenUrl(url: string, title?: string): Observable<string> {
    const params = new HttpParams()
      .set('link', url)
      .set('title', title??'TechInsights');
    return this.httpClient.get<any>(this.baseUrl, { params }).pipe(
      map((response: any) => response.shortUrl),
      catchError(() => of(url))
    )
  }
}
